//SCREENS
var gameScreen = {};

//draw
gameScreen.draw = function (resources) {
  var s = gameScreen;
  s.root = new Container(screen_container);
  screen_container.toBack(s.root);

  //    s.guide = new WhiteRectangle(s.root, [3000, 33], primaryPalette[1]);
  //    s.guide.anchor.set(0);
  //    s.guide.alpha=0.2;

  s.background = new WhiteRectangle(s.root, [5, 5], 0xdae3e9);
  s.background.alpha = 1;
  s.background.anchor.set(0);
  s.background.interactive = true;
  s.background.onPointerUp = function (e) {
    gameLogic.unselectAll();
  };
  s.background.on("pointerup", s.background.onPointerUp);

  s.backgroundBlack = new WhiteRectangle(s.root, [5, 5], 0x000000);
  s.backgroundBlack.alpha = 0;
  s.backgroundBlack.anchor.set(0);

  s.dust = new Dust(s.root, 2, 40, [0xffffff, 0xffffdd, 0xffddff, 0xddffff], 1);
  s.dust.alpha = 0;

  s.bgGlow = new Sprite(s.root, imgRoot + "glow.svg");
  s.bgGlow.alpha = 0;

  s.bgGlowBlack = new Sprite(s.root, imgRoot + "glow.svg");
  s.bgGlowBlack.alpha = 0;
  s.bgGlowBlack.tint = 0x000000;

  s.numContParent = new Container(s.root);
  s.numbersContainer = new Container(s.numContParent);
  s.dotsContainer = new Container(s.numbersContainer);

  s.nextNumContainer = new Container(s.root);
  s.nextSprite = new Sprite(s.nextNumContainer, "next1.png");

  s.whiteCircle = new Circle(s.nextNumContainer, s.nextSprite.width * 0.55);
  s.maskCircle = new Circle(s.nextNumContainer, s.nextSprite.width * 0.5, [0, 0, 0], [0xffffff, 1], false);
  s.nextSprite.mask = s.maskCircle;

  var angles = [];
  var colors = [];
  for (var i = 0; i < gameLogic.drawDeck.length + 2; i++) {
    angles.push((i * 360) / (gameLogic.drawDeck.length + 1) - 90);
    colors.push(primaryPalette[1]);
  }
  s.progressPie = new Pie(s.nextNumContainer, s.nextSprite.width * 0.6, angles, [0.1, 0, 1], colors, true);

  gameScreen.resetProgress();

  s.nextNumContainer.toBack(s.progressPie);
  s.nextNumContainer.toFront(s.nextSprite);

  var scoreTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 40,
    fill: [primaryPalette[1]],
    align: "right",
  });

  var noValidTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 32,
    fill: [0xf8273a],
    align: "center",
  });

  var bestScoreTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 25,
    fill: [primaryPalette[1]],
    align: "right",
  });

  s.scoreContainer = new Container(s.root);
  s.scoreText = new Text(s.scoreContainer, "", scoreTextStyle);
  s.scoreText.anchor.set(1, 0);

  s.trophySprite = new Sprite(s.scoreContainer, "trophy.png");
  s.trophySprite.anchor.set(1, 0);
  s.trophySprite.y = s.scoreText.height - 1;
  s.trophySprite.x = -2;
  s.trophySprite.alpha = 0.5;

  s.bestScoreText = new Text(s.scoreContainer, "0", bestScoreTextStyle);
  s.bestScoreText.alpha = 0.5;
  s.bestScoreText.anchor.set(1, 0);
  s.bestScoreText.y = s.scoreText.height - 6;
  s.bestScoreText.x = -s.trophySprite.width - 4;

  s.menuBtnContainer = new Container(s.root);
  s.menuBtn = new SpriteButton(s.menuBtnContainer, s.openMenu, "menuBtn.png", true, [2, 2]);
  s.menuBtn.setTransform(s.menuBtn.width / 4, s.menuBtn.height / 4);

  var timerStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 32,
    fill: [0x000000],
    align: "center",
    lineJoin: "round",
    miterLimit: 0,
    stroke: "white",
    strokeThickness: 10,
  });

  s.powerUpContainer = new Container(s.root);
  s.powerUpBtns = [];

  s.powerUpBtns[0] = new Button(s.powerUpContainer, "", "PU_0.png", null, PU_BUTTON);
  s.powerUpBtns[0].adSprite = new Sprite(s.powerUpBtns[0], "adIcon.png");
  s.powerUpBtns[0].adSprite.setTransform(40, 40, 0.75, 0.75);
  s.powerUpBtns[0].timer = new Text(s.powerUpBtns[0], "", timerStyle);
  s.powerUpBtns[0].x = -150;
  s.powerUpBtns[0].stX = s.powerUpBtns[0].x;
  s.powerUpBtns[0].callback = function () {
    if (gameLogic.lock) return;

    if (gameLogic.activePowerUps[0]) {
      s.openPowerUpInfo(gameLogic.PU_1to2);
    }
  };

  s.powerUpBtns[1] = new Button(s.powerUpContainer, "", "PU_1.png", null, PU_BUTTON);
  s.powerUpBtns[1].adSprite = new Sprite(s.powerUpBtns[1], "adIcon.png");
  s.powerUpBtns[1].adSprite.setTransform(40, 40, 0.75, 0.75);
  s.powerUpBtns[1].timer = new Text(s.powerUpBtns[1], "", timerStyle);
  s.powerUpBtns[1].x = 0;
  s.powerUpBtns[1].stX = s.powerUpBtns[1].x;
  s.powerUpBtns[1].callback = function () {
    if (gameLogic.lock) return;

    if (gameLogic.activePowerUps[1]) {
      s.openPowerUpInfo(gameLogic.PU_WILD);
    }
  };

  s.powerUpBtns[2] = new Button(s.powerUpContainer, "", "PU_2.png", null, PU_BUTTON);
  s.powerUpBtns[2].adSprite = new Sprite(s.powerUpBtns[2], "adIcon.png");
  s.powerUpBtns[2].adSprite.setTransform(40, 40, 0.75, 0.75);
  s.powerUpBtns[2].timer = new Text(s.powerUpBtns[2], "", timerStyle);
  s.powerUpBtns[2].x = 150;
  s.powerUpBtns[2].stX = s.powerUpBtns[2].x;
  s.powerUpBtns[2].callback = function () {
    if (gameLogic.lock) return;

    if (!gameLogic.shifting) {
      s.openPowerUpInfo(gameLogic.PU_SHIFT);
    }
  };

  //setInterval(s.updatePowerUpsTimer, 1000);

  s.shiftDoneBtn = new SpriteButton(s.powerUpContainer, null, "check.png", true, [1.5, 1.5]);
  s.shiftDoneBtn.x = 0;
  s.noValidMovesText = new Text(s.powerUpContainer, "", noValidTextStyle);
  s.noValidMovesText.visible = false;
  s.shiftDoneBtn.y = 200;
  s.shiftDoneBtn.scale.set(0.4);
  s.shiftDoneBtn.stY = s.shiftDoneBtn.y;
  s.shiftDoneBtn.callback = function () {
    if (gameLogic.shifting) {
      playSound("btnClick");
      gameLogic.stopShifting();
      gameLogic.activePowerUps[2] = false;
      gameScreen.updatePowerUps();
      gameLogic.saveState(true);
    }
  };

  s.isDrawn = true;
  s.resize();
  s.root.visible = false;

  //localStorage.clear();
  if (!gameLogic.loadState()) {
    if (loadObject("seenTutorial")) {
      gameScreen.drawLevel(levels[0], true);
      gameLogic.resetGame(true);
    } else {
      gameScreen.drawLevel(levels[0], false);
      gameLogic.resetGame(false);
      tutorial.draw(s.numbersContainer);
      gameScreen.updatePowerUps();
    }
  }
};

gameScreen.drawLevel = function (state, shuffle) {
  var s = gameScreen;
  gameLogic.m = state.matrix.length;
  gameLogic.n = state.matrix[0].length;
  s.nextNumContainer.defScale = 1;
  s.shiftColBtns = [];
  s.shiftRowBtns = [];
  if (shuffle == undefined) shuffle = true;

  var v, t, c, l;

  if (shuffle) shuffleArray(state.matrix);

  for (var i = 0; i < gameLogic.m; i++) {
    if (shuffle) shuffleArray(state.matrix[i]);

    gameLogic.numbers[i] = [];
    for (var j = 0; j < gameLogic.n; j++) {
      v = state.matrix[i][j].v;
      l = state.matrix[i][j].l;

      gameLogic.numbers[i][j] = new NumberShape(s.numbersContainer, v, l);
      gameLogic.numbers[i][j].position = s.getNumberPos(i, j);
      gameLogic.numbers[i][j].i = i;
      gameLogic.numbers[i][j].j = j;
    }
  }

  for (var k = 0; k < gameLogic.n * 2; k++) {
    var j = k % gameLogic.n;
    s.shiftColBtns[k] = new Button(s.numbersContainer, "", ["play.png"], null, SHIFT_BUTTON);
    s.shiftColBtns[k].column = j;

    s.shiftColBtns[k].callback = function () {
      gameLogic.shiftColumn(this.column, this.dir);
    };
    s.shiftColBtns[k].stX = gameLogic.numbers[0][j].x;
    if (k < gameLogic.n) {
      s.shiftColBtns[k].dir = -1;
      s.shiftColBtns[k].stY = gameLogic.numbers[0][j].y - 225;
    } else {
      s.shiftColBtns[k].dir = 1;
      s.shiftColBtns[k].stY = gameLogic.numbers[gameLogic.m - 1][j].y + 225;
    }
    s.shiftColBtns[k].setTransform(s.shiftColBtns[k].stX, s.shiftColBtns[k].stY);
    s.shiftColBtns[k].rotation = (s.shiftColBtns[k].dir * Math.PI) / 2;
    s.shiftColBtns[k].alpha = 0;
    s.shiftColBtns[k].disable();
  }

  for (var k = 0; k < gameLogic.m * 2; k++) {
    var i = k % gameLogic.m;
    s.shiftRowBtns[k] = new Button(s.numbersContainer, "", ["play.png"], null, SHIFT_BUTTON);
    s.shiftRowBtns[k].row = i;

    s.shiftRowBtns[k].callback = function () {
      gameLogic.shiftRow(this.row, this.dir);
    };
    s.shiftRowBtns[k].stY = gameLogic.numbers[i][0].y;
    if (k < gameLogic.m) {
      s.shiftRowBtns[k].dir = -1;
      s.shiftRowBtns[k].stX = gameLogic.numbers[i][0].x - 225;
    } else {
      s.shiftRowBtns[k].dir = 1;
      s.shiftRowBtns[k].stX = gameLogic.numbers[i][gameLogic.n - 1].x + 225;
    }
    s.shiftRowBtns[k].setTransform(s.shiftRowBtns[k].stX, s.shiftRowBtns[k].stY);
    s.shiftRowBtns[k].rotation = ((s.shiftRowBtns[k].dir - 1) * Math.PI) / 2;
    s.shiftRowBtns[k].alpha = 0;
    s.shiftRowBtns[k].disable();
  }

  s.drawDots();

  s.numbersContainer.alpha = 0;
  TweenMax.to(s.numbersContainer, 0.5, {
    pixi: {
      alpha: 1,
    },
    delay: 0.2,
  });

  s.resize();
};

gameScreen.drawDots = function () {
  var s = gameScreen;
  var numOfDots = 12;
  for (var i = 0; i < gameLogic.m; i++) {
    for (var j = 0; j < gameLogic.n; j++) {
      if (gameLogic.numbers[i][j] == undefined) continue;

      var xDots = [];
      var yDots = [];
      for (var k = 0; k < numOfDots; k++) {
        //xDots
        if (j < gameLogic.n - 1) {
          if (gameLogic.numbers[i][j + 1]) {
            xDots[k] = new Circle(s.dotsContainer, 6);
            xDots[k].tint = primaryPalette[1];
            xDots[k].alpha = 0.1;
            xDots[k].scale.set(0.5);
            xDots[k].x = gameLogic.numbers[i][j].x + ((gameLogic.numbers[i][j + 1].x - gameLogic.numbers[i][j].x) * (k + 0.5)) / numOfDots;
            xDots[k].y = gameLogic.numbers[i][j].y + ((gameLogic.numbers[i][j + 1].y - gameLogic.numbers[i][j].y) * (k + 0.5)) / numOfDots;
            gameLogic.numbers[i][j].rightDots = xDots;
            gameLogic.numbers[i][j + 1].leftDots = xDots;
          }
        }
        //yDots
        if (i < gameLogic.m - 1) {
          if (gameLogic.numbers[i + 1][j]) {
            yDots[k] = new Circle(s.dotsContainer, 6);
            yDots[k].tint = primaryPalette[1];
            yDots[k].alpha = 0.1;
            yDots[k].scale.set(0.5);
            yDots[k].x = gameLogic.numbers[i][j].x + ((gameLogic.numbers[i + 1][j].x - gameLogic.numbers[i][j].x) * (k + 0.5)) / numOfDots;
            yDots[k].y = gameLogic.numbers[i][j].y + ((gameLogic.numbers[i + 1][j].y - gameLogic.numbers[i][j].y) * (k + 0.5)) / numOfDots;
            gameLogic.numbers[i][j].downDots = yDots;
            gameLogic.numbers[i + 1][j].upDots = yDots;
          }
        }
      }
    }
  }
};

gameScreen.updateNextValue = function (nextValue) {
  TweenMax.to(gameScreen.nextSprite, 0.3, {
    pixi: {
      y: 150,
    },
    ease: Power2.easeIn,
    delay: 0.1,
    onComplete: function () {
      gameScreen.nextSprite.y = -150;
      if (nextValue != 0) {
        gameScreen.nextSprite.texture = PIXI.utils.TextureCache["next" + nextValue + ".png"];
      } else {
        gameScreen.nextSprite.texture = PIXI.utils.TextureCache["next0_0.png"];
      }
      TweenMax.to(gameScreen.nextSprite, 0.3, {
        pixi: {
          y: 0,
        },
        ease: Power2.easeOut,
      });
    },
  });
};

gameScreen.updateProgress = function (progress) {
  var len = gameScreen.progressPie.sectors.length;
  if (gameScreen.progressPie.resetTween) {
    gameScreen.progressPie.resetTween.kill();
    gameScreen.resetProgress();
    gameScreen.progressPie.resetTween = null;
  }
  for (var i = 0; i < len; i++) {
    if (i <= len * progress) {
      TweenMax.to(gameScreen.progressPie.sectors[i], 0.2, {
        pixi: {
          alpha: 1,
        },
        ease: Power2.easeOut,
        delay: 0.4,
      });
    } else {
      TweenMax.to(gameScreen.progressPie.sectors[i], 0.2, {
        pixi: {
          alpha: 0,
        },
        ease: Power2.easeOut,
        delay: 0.4,
      });
    }
  }
  if (progress == 1) {
    gameScreen.progressPie.resetTween = TweenMax.to(gameScreen.progressPie, 0.3, {
      pixi: {
        alpha: 0,
      },
      ease: Power2.easeOut,
      yoyo: true,
      repeat: -1,
      delay: 0.4,
      onComplete: function () {
        gameScreen.resetProgress();
      },
    });
  }
};

gameScreen.resetProgress = function () {
  TweenMax.to(gameScreen.progressPie, 0.2, {
    pixi: {
      alpha: 1,
    },
    ease: Power2.easeOut,
  });
  for (var i = 0; i < gameScreen.progressPie.sectors.length; i++) {
    TweenMax.to(gameScreen.progressPie.sectors[i], 0.2, {
      pixi: {
        alpha: 0,
      },
      ease: Power2.easeOut,
    });
  }
};

gameScreen.enlargePowerUps = function () {
  var s = gameScreen;

  s.bgGlowBlack.alphaTween = TweenMax.to([s.bgGlowBlack], 2, {
    pixi: {
      alpha: 0.1,
    },
    repeat: -1,
    yoyo: true,
  });

  s.backgroundBlack.alphaTween = TweenMax.to(s.backgroundBlack, 2, {
    pixi: {
      alpha: 0.2,
    },
    repeat: -1,
    yoyo: true,
  });

  for (var i = 0; i < s.powerUpBtns.length; i++) {
    TweenMax.to(s.powerUpBtns[i], 0.3, {
      pixi: {
        scale: 1.2,
        x: s.powerUpBtns[i].stX * 1.25,
        y: -15,
      },
      ease: Power2.easeOut,
      delay: 1 + i * 0.1,
    });

    if (gameLogic.activePowerUps[i]) {
      s.powerUpBtns[i].shakeInterval = setInterval(
        function (ind) {
          shakeScreen(5, 250, gameScreen.powerUpBtns[ind].img);
        },
        3000 + i * 100,
        i
      );
    }
  }

  TweenMax.to(s.numbersContainer, 1, {
    pixi: {
      alpha: 1,
    },
    delay: 1,
  });
};

gameScreen.shrinkPowerUps = function (tweenButtons) {
  if (tutorial.isDrawn) return;

  if (tweenButtons == undefined) tweenButtons = true;

  var s = gameScreen;
  if (s.bgGlowBlack.alphaTween) {
    s.bgGlowBlack.alphaTween.kill();
    s.backgroundBlack.alphaTween.kill();
    s.bgGlowBlack.alphaTween = null;
    s.backgroundBlack.alphaTween = null;
    TweenMax.to([s.bgGlowBlack, s.backgroundBlack], 0.5, {
      pixi: {
        alpha: 0,
      },
    });
  }

  for (var i = 0; i < s.powerUpBtns.length; i++) {
    clearInterval(s.powerUpBtns[i].shakeInterval);
    if (tweenButtons) {
      TweenMax.to(s.powerUpBtns[i], 0.3, {
        pixi: {
          scale: 1,
          x: s.powerUpBtns[i].stX,
          y: 0,
        },
        ease: Power2.easeOut,
        delay: i * 0.1,
      });
    }
  }

  TweenMax.to(s.numbersContainer, 0.5, {
    pixi: {
      alpha: 1,
    },
  });
};

gameScreen.updatePowerUpsTimer = function () {
  var s = gameScreen;
  if (!s.powerUpBtns) return;

  var wait = ads.getWaitingTime();
  for (var i = 0; i < s.powerUpBtns.length; i++) {
    if (gameLogic.activePowerUps[i]) {
      if (wait > 0) {
        s.powerUpBtns[i].timer.text = milliToMMSS(wait);
        gameScreen.powerUpBtns[i].disable();
        gameScreen.powerUpBtns[i].adSprite.visible = false;
      } else {
        s.powerUpBtns[i].timer.text = "";
        gameScreen.powerUpBtns[i].enable();
        gameScreen.powerUpBtns[i].adSprite.visible = true;
      }
    } else {
      s.powerUpBtns[i].timer.text = "X";
      gameScreen.powerUpBtns[i].disable();
      gameScreen.powerUpBtns[i].adSprite.visible = false;
    }
  }
};

gameScreen.updatePowerUps = function () {
  setTimeout(function () {
    var s = gameScreen;
    if (tutorial.isDrawn || gameLogic.gameOver) {
      for (var i = 0; i < s.powerUpBtns.length; i++) {
        TweenMax.to(s.powerUpBtns[i], 0.25, {
          pixi: {
            y: s.shiftDoneBtn.stY,
          },
          ease: Power2.easeIn,
        });
      }
      return;
    }

    for (var i = 0; i < s.powerUpBtns.length; i++) {
      if (gameLogic.activePowerUps[i]) {
        gameScreen.powerUpBtns[i].enable();
        gameScreen.powerUpBtns[i].adSprite.visible = false;
      } else {
        gameScreen.powerUpBtns[i].disable();
        gameScreen.powerUpBtns[i].adSprite.visible = false;
        clearInterval(s.powerUpBtns[i].shakeInterval);
      }
    }

    if (gameLogic.shifting) {
      for (var i = 0; i < s.powerUpBtns.length; i++) {
        TweenMax.to(s.powerUpBtns[i], 0.25, {
          pixi: {
            y: s.shiftDoneBtn.stY,
          },
          ease: Power2.easeIn,
        });
      }

      TweenMax.to(s.shiftDoneBtn, 0.25, {
        pixi: {
          y: 0,
        },
        ease: Power2.easeOut,
        delay: 0.5,
      });
    } else {
      for (var i = 0; i < s.powerUpBtns.length; i++) {
        TweenMax.to(s.powerUpBtns[i], 0.25, {
          pixi: {
            y: 0,
            x: s.powerUpBtns[i].stX,
            scale: 1,
          },
          ease: Power2.easeOut,
          delay: 0.5,
        });
      }

      TweenMax.to(s.shiftDoneBtn, 0.25, {
        pixi: {
          y: s.shiftDoneBtn.stY,
        },
        ease: Power2.easeIn,
      });
    }
  }, 50);
};

gameScreen.disableShiftDone = function () {
  var s = gameScreen;
  s.shiftDoneBtn.visible = false;
  s.noValidMovesText.visible = true;
  s.noValidMovesText.alpha = 1;
  s.noValidMovesText.text = "x";

  s.noValidMovesText.alphaTween = TweenMax.to(s.noValidMovesText, 0.66, {
    pixi: {
      alpha: 1,
    },
    repeat: -1,
    yoyo: true,
  });
};

gameScreen.enableShiftDone = function () {
  var s = gameScreen;
  s.shiftDoneBtn.visible = true;
  s.noValidMovesText.visible = false;

  if (s.noValidMovesText.alphaTween) {
    s.noValidMovesText.alphaTween.kill();
    s.noValidMovesText.alphaTween = null;
  }
};

gameScreen.getNumberPos = function (i, j) {
  var pos = {};
  var space = 300;
  pos.x = -(space * (gameLogic.n - 1)) / 2 + j * space;
  pos.y = -(space * (gameLogic.m - 1)) / 2 + i * space;
  return pos;
};

gameScreen.updateDots = function (a, b, connect, remove) {
  var dots;
  var scale = 0.75;
  var alpha = 0.5;
  if (!connect && !remove) {
    scale = 0.5;
    alpha = 0.1;
  }
  if (remove) {
    scale = 0;
    alpha = 0;
  }

  var id = a.i - b.i;
  var jd = a.j - b.j;
  var dir = id + jd;

  if (id == 0 && jd == -1) {
    dots = a.rightDots;
    if (remove) {
      a.rightDots = null;
      b.leftDots = null;
    }
  }
  if (id == 0 && jd == 1) {
    dots = a.leftDots;
    if (remove) {
      b.rightDots = null;
      a.leftDots = null;
    }
  }
  if (id == -1 && jd == 0) {
    dots = a.downDots;
    if (remove) {
      a.downDots = null;
      b.upDots = null;
    }
  }
  if (id == 1 && jd == 0) {
    dots = a.upDots;
    if (remove) {
      b.downDots = null;
      a.upDots = null;
    }
  }

  if (dots == undefined) {
    return;
  }
  var len = dots.length;
  var delay;
  for (var i = 0; i < len; i++) {
    if (!dots[i]) return;
    delay = distance(dots[i], a) * 0.0002;

    dots[i].tween = TweenMax.to(dots[i], 0.12, {
      pixi: {
        scale: scale,
        alpha: alpha,
      },
      delay: delay,
      ease: Power2.easeIn,
      onComplete: function (d, r) {
        if (r) {
          d.delete();
        }
      },
      onCompleteParams: [dots[i], remove],
    });
  }
};

gameScreen.disconnectDots = function (nums) {
  for (var i = 1; i < nums.length; i++) {
    gameScreen.updateDots(nums[i], nums[i - 1], false, false);
  }
};

gameScreen.clearLevel = function (revive) {
  var s = gameScreen;
  gameLogic.numbers = [];
  TweenMax.to(s.numbersContainer, 0.5, {
    pixi: {
      alpha: 0,
    },
    onComplete: function (revive) {
      var s = gameScreen;
      s.numContParent.delete();
      s.numContParent = new Container(s.root);
      s.numbersContainer = new Container(s.numContParent);
      s.dotsContainer = new Container(s.numbersContainer);
      s.resize();
      if (!revive) {
        gameLogic.resetLevel();
        s.drawLevel(levels[0]);
        gameLogic.resetGame();
      } else {
        gameLogic.revive();
      }
    },
    onCompleteParams: [revive],
  });
};
gameScreen.showShiftButtons = function () {
  var s = gameScreen;
  for (var j = 0; j < gameLogic.n * 2; j++) {
    s.shiftColBtns[j].enable();
    s.shiftColBtns[j].img.x = -5;
    TweenMax.to(s.shiftColBtns[j], 0.5, {
      pixi: {
        alpha: 1,
      },
      delay: 0.5,
    });

    s.shiftColBtns[j].moveTweeen = TweenMax.to(s.shiftColBtns[j].img, 0.66, {
      pixi: {
        x: 10,
      },
      yoyo: true,
      repeat: -1,
      ease: Power2.easeIn,
    });
  }

  for (var i = 0; i < gameLogic.m * 2; i++) {
    s.shiftRowBtns[i].enable();
    s.shiftRowBtns[i].img.x = -5;
    TweenMax.to(s.shiftRowBtns[i], 0.5, {
      pixi: {
        alpha: 1,
      },
      delay: 0.5,
    });

    s.shiftRowBtns[i].moveTweeen = TweenMax.to(s.shiftRowBtns[i].img, 0.66, {
      pixi: {
        x: 10,
      },
      yoyo: true,
      repeat: -1,
      ease: Power2.easeIn,
    });
  }

  for (var i = 0; i < gameLogic.m; i++) {
    for (var j = 0; j < gameLogic.n; j++) {
      TweenMax.to(gameLogic.numbers[i][j].gemSprite, 0.5, {
        pixi: {
          alpha: 0.5,
        },
        delay: 0.5,
      });
    }
  }

  TweenMax.to(s.numbersContainer, 0.25, {
    pixi: {
      scale: 0.8,
    },
    ease: Power2.easeOut,
  });

  //    for (var i = 0; i < s.powerUpBtns.length; i++) {
  //        TweenMax.to(s.powerUpBtns[i], 0.25, {
  //            pixi: {
  //                y: s.shiftDoneBtn.stY
  //            },
  //            ease: Power2.easeIn
  //        });
  //    }
  //
  //    TweenMax.to(s.shiftDoneBtn, 0.25, {
  //        pixi: {
  //            y: 0
  //        },
  //        ease: Power2.easeOut,
  //        delay: 0.5
  //    });
};

gameScreen.hideShiftButtons = function () {
  var s = gameScreen;
  for (var j = 0; j < gameLogic.n * 2; j++) {
    s.shiftColBtns[j].disable();
    TweenMax.to(s.shiftColBtns[j], 0.5, {
      pixi: {
        alpha: 0,
      },
      //delay: (j % gameLogic.n) * 0.1,
      onComplete: function (btn) {
        if (btn.moveTweeen != undefined) btn.moveTweeen.kill();
      },
      onCompleteParams: [s.shiftColBtns[j]],
    });
  }

  for (var i = 0; i < gameLogic.m * 2; i++) {
    s.shiftRowBtns[i].disable();
    TweenMax.to(s.shiftRowBtns[i], 0.5, {
      pixi: {
        alpha: 0,
      },
      //delay: (j % gameLogic.n) * 0.1,
      onComplete: function (btn) {
        if (btn.moveTweeen != undefined) btn.moveTweeen.kill();
      },
      onCompleteParams: [s.shiftRowBtns[i]],
    });
  }

  for (var i = 0; i < gameLogic.m; i++) {
    for (var j = 0; j < gameLogic.n; j++) {
      TweenMax.to(gameLogic.numbers[i][j].gemSprite, 0.5, {
        pixi: {
          alpha: 1,
        },
        delay: 0,
      });
    }
  }

  TweenMax.to(s.numbersContainer, 0.25, {
    pixi: {
      scale: 1,
    },
    ease: Power2.easeOut,
    delay: 0.5,
  });

  //    for (var i = 0; i < s.powerUpBtns.length; i++) {
  //        TweenMax.to(s.powerUpBtns[i], 0.25, {
  //            pixi: {
  //                y: 0
  //            },
  //            ease: Power2.easeOut,
  //            delay: 0.5
  //        });
  //    }
  //
  //    TweenMax.to(s.shiftDoneBtn, 0.25, {
  //        pixi: {
  //            y: s.shiftDoneBtn.stY
  //        },
  //        ease: Power2.easeIn,
  //
  //    });
};

gameScreen.openMenu = function () {
  if (gameLogic.gameOver) return;

  gameScreen.menuOpened = true;
  gameLogic.lock = true;
  ads.gameplayStop();
  playSound("btnClick");
  var p = alertPopup();
  var titleTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 120,
    fill: [primaryPalette[1]],
    align: "center",
  });

  var title = new Text(p.content, "Gem·11", titleTextStyle);
  title.setTransform(0, -400);

  var playBtn = new Button(
    p.content,
    "",
    ["play.png"],
    function () {
      closePopup();
      gameScreen.menuOpened = false;
      p.closeCallback = function () {
        gameLogic.lock = false;
      };
      playBtn.disable();
      ads.gameplayStart();
    },
    PLAY_BUTTON
  );
  playBtn.setTransform(0, 0);
  playBtn.img.setTransform(15, 0);

  var restartBtn = new Button(
    p.content,
    "",
    ["undo-alt.png"],
    function () {
      gameLogic.clearState();
      setTimeout(gameScreen.clearLevel, 750);
      gameLogic.lock = true;
      gameLogic.shifting = false;
      closePopup();
      gameScreen.menuOpened = false;
      restartBtn.disable();
      ads.showAd();
      ads.gameplayStart();
    },
    ICON_BUTTON
  );
  restartBtn.setTransform(-150, 415);

  if (tutorial.isDrawn) {
    restartBtn.disable();
    restartBtn.alpha = 0.3;
  }

  //setInterval(playBtn.callback, 3000);
  var imgA = ["volume-down.png", "volume-mute.png"];
  if (!soundOn) imgA.reverse();

  var soundBtn = new Button(
    p.content,
    "",
    imgA,
    function () {
      toggleSound();
    },
    ICON_BUTTON
  );
  soundBtn.setTransform(150, 415);

  //setTimeout(drawGuideLines());

  //    var share = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.shareText(getText("share"));
  //
  //        }
  //    }
  //
  //    var shareBtn = new Button(p.content, "", "share.png", share, ICON_BUTTON);
  //    shareBtn.setTransform(200, 350);
  //
  //
  //
  //    var signInOut = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.signInOut();
  //        }
  //
  //        gameScreen.signInOutBtn.disable();
  //    }
  //
  //    var img = "googleSignIn.png"
  //    if (!signing.signedIn)
  //        img = "googleSignOut.png"
  //
  //    gameScreen.signInOutBtn = new Button(p.content, "", img, signInOut, ICON_BUTTON);
  //    gameScreen.signInOutBtn.setTransform(-200, 475);
  //
  //
  //
  //    var showAchievements = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showAchievements();
  //        }
  //    }
  //
  //
  //    var showLeaderboard = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showLeaderboard(0);
  //        }
  //    }
  //
  //    var leaderboardBtn = new Button(p.content, "", "leaderboard.png", showLeaderboard, ICON_BUTTON);
  //    leaderboardBtn.setTransform(0, 475);
  //
  //    var showAchievements = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showAchievements();
  //        }
  //    }
  //    var achievementsBtn = new Button(p.content, "", "achievements.png", showAchievements, ICON_BUTTON);
  //    achievementsBtn.setTransform(200 , 475);
};

gameScreen.onSignIn = function () {
  if (gameScreen.menuOpened) {
    gameScreen.signInOutBtn.enable();
    gameScreen.signInOutBtn.setImg("googleSignIn.png");
  }
};

gameScreen.onSignInError = function () {
  if (gameScreen.menuOpened) {
    gameScreen.signInOutBtn.enable();
  }
};

gameScreen.onSignOut = function () {
  if (gameScreen.menuOpened) {
    gameScreen.signInOutBtn.enable();
    gameScreen.signInOutBtn.setImg("googleSignOut.png");
  }
};

gameScreen.onSignOutError = function () {
  if (gameScreen.menuOpened) {
    gameScreen.signInOutBtn.enable();
  }
};

gameScreen.openGameOver = function () {
  gameLogic.clearState();
  analyticsCustiomEvent("Score", gameLogic.score);
  if (window.JSInterface != undefined) {
    window.JSInterface.submitScore(0, gameLogic.score);
  }
  ads.gameplayStop();
  var p = alertPopup();

  var scoreTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 150,
    fill: [primaryPalette[1]],
    align: "center",
  });

  var bestScoreTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 30,
    fill: [primaryPalette[1]],
    align: "right",
  });

  var score = new Text(p.content, "0", scoreTextStyle);
  TweenMax.to(score, 0.3, {
    pixi: {
      y: -150,
    },
    delay: 2.75,
    ease: Power2.easeInOut,
  });

  var bestScore = new Text(p.content, gameLogic.bestScore, bestScoreTextStyle);
  bestScore.anchor.set(1, 0.5);

  var trophySprite = new Sprite(p.content, "trophy.png");
  trophySprite.anchor.set(0, 0.5);
  trophySprite.scale.set(1.1);

  var gap = 4;
  bestScore.setTransform(bestScore.width / 2 - trophySprite.width / 2 - gap / 2, -50);
  trophySprite.setTransform(bestScore.x + gap, bestScore.y);

  bestScore.alpha = 0;
  trophySprite.alpha = 0;

  TweenMax.to([bestScore, trophySprite], 0.2, {
    pixi: {
      alpha: 1,
    },
    delay: 3.1,
  });

  var timeout = setTimeout(countText, 750, score, 0, gameLogic.score, 1500, ["scoreCount"]);

  var restartBtn = new Button(
    p.content,
    "",
    ["undo-alt.png"],
    function () {
      setTimeout(gameScreen.clearLevel, 1000);
      gameLogic.lock = true;
      closePopup();
      clearTimeout(timeout);
      restartBtn.disable();
      ads.showAd();
      ads.gameplayStart();
    },
    RESTART_BUTTON
  );
  restartBtn.setTransform(0, 150);

  restartBtn.alpha = 0;
  restartBtn.scale.set(0.5);
  TweenMax.to(restartBtn, 0.3, {
    pixi: {
      scale: 1,
      alpha: 1,
    },
    delay: 3.2,
    ease: Back.easeOut.config(1.7),
  });

  //    var showLeaderboard = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showLeaderboard(0);
  //        }
  //    }
  //    var leaderboardBtn = new Button(p.content, "", "leaderboard.png", showLeaderboard, ICON_BUTTON);
  //    leaderboardBtn.setTransform(-150, 350);
  //    leaderboardBtn.alpha = 0;
  //    leaderboardBtn.scale.set(0.5);
  //    TweenMax.to(leaderboardBtn, 0.3, {
  //        pixi: {
  //            scale: 1,
  //            alpha: 1,
  //        },
  //        delay: 3.3,
  //        ease: Back.easeOut.config(1.7),
  //    });
  //
  //    var showAchievements = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showAchievements();
  //        }
  //    }
  //    var achievementsBtn = new Button(p.content, "", "achievements.png", showAchievements, ICON_BUTTON);
  //    achievementsBtn.setTransform(0, 350);
  //    achievementsBtn.alpha = 0;
  //    achievementsBtn.scale.set(0.5);
  //    TweenMax.to(achievementsBtn, 0.3, {
  //        pixi: {
  //            scale: 1,
  //            alpha: 1,
  //        },
  //        delay: 3.4,
  //        ease: Back.easeOut.config(1.7),
  //    });
  //
  //    var share = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.shareText(getText("shareScore", [gameLogic.score]));
  //
  //        }
  //    }
  //
  //    var shareBtn = new Button(p.content, "", "share.png", share, ICON_BUTTON);
  //    shareBtn.setTransform(150, 350);
  //    shareBtn.alpha = 0;
  //    shareBtn.scale.set(0.5);
  //    TweenMax.to(shareBtn, 0.3, {
  //        pixi: {
  //            scale: 1,
  //            alpha: 1,
  //        },
  //        delay: 3.5,
  //        ease: Back.easeOut.config(1.7),
  //    });
};

gameScreen.openWin = function (value, level, i, j) {
  gameLogic.clearState();
  analyticsCustiomEvent("Win");
  analyticsCustiomEvent("Score", gameLogic.score);
  if (window.JSInterface != undefined) {
    window.JSInterface.submitScore(0, gameLogic.score);
  }
  ads.gameplayStop();
  var p = alertPopup();

  var scoreTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 150,
    fill: [primaryPalette[1]],
    align: "center",
  });

  var bestScoreTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 30,
    fill: [primaryPalette[1]],
    align: "right",
  });

  var mainDelay = 7.5;

  var gem = new NumberShape(p.content, value, level);

  TweenMax.to(gem, 0.3, {
    pixi: {
      alpha: 0,
      scale: 0.5,
    },
    delay: mainDelay - 0.4,
    ease: Back.easeIn.config(1.7),
  });
  playSound("win");

  setTimeout(fadeToColor, mainDelay * 1000, p.overlay, 0xffffff, 0.99, 1000);
  setTimeout(
    function (v, l, i, j) {
      gameLogic.numbers[i][j] = new NumberShape(gameScreen.numbersContainer, v, l);
      gameLogic.numbers[i][j].position = gameScreen.getNumberPos(i, j);
      gameLogic.numbers[i][j].i = i;
      gameLogic.numbers[i][j].j = j;
    },
    mainDelay * 1000,
    value,
    level,
    i,
    j
  );

  var score = new Text(p.content, "0", scoreTextStyle);
  score.alpha = 0;
  score.scale.set(0.5);

  TweenMax.to(score, 0.2, {
    pixi: {
      alpha: 1,
      scale: 1,
    },
    delay: mainDelay,
    ease: Power2.easeInOut,
  });
  TweenMax.to(score, 0.3, {
    pixi: {
      y: -150,
    },
    delay: 2.75 + mainDelay,
    ease: Power2.easeInOut,
  });

  var bestScore = new Text(p.content, gameLogic.bestScore, bestScoreTextStyle);
  bestScore.anchor.set(1, 0.5);

  var trophySprite = new Sprite(p.content, "trophy.png");
  trophySprite.anchor.set(0, 0.5);
  trophySprite.scale.set(1.1);

  var gap = 4;
  bestScore.setTransform(bestScore.width / 2 - trophySprite.width / 2 - gap / 2, -50);
  trophySprite.setTransform(bestScore.x + gap, bestScore.y);

  bestScore.alpha = 0;
  trophySprite.alpha = 0;

  TweenMax.to([bestScore, trophySprite], 0.2, {
    pixi: {
      alpha: 1,
    },
    delay: 3.1 + mainDelay,
  });

  var timeout = setTimeout(countText, 750 + mainDelay * 1000, score, 0, gameLogic.score, 1500, ["scoreCount"]);

  var restartBtn = new Button(
    p.content,
    "",
    ["undo-alt.png"],
    function () {
      setTimeout(gameScreen.clearLevel, 1000);
      gameLogic.lock = true;
      closePopup();
      clearTimeout(timeout);
      restartBtn.disable();
      ads.showAd();
      ads.gameplayStart();
    },
    RESTART_BUTTON
  );
  restartBtn.setTransform(0, 150);

  restartBtn.alpha = 0;
  restartBtn.scale.set(0.5);
  TweenMax.to(restartBtn, 0.3, {
    pixi: {
      scale: 1,
      alpha: 1,
    },
    delay: 3.2 + mainDelay,
    ease: Back.easeOut.config(1.7),
  });

  //    var showLeaderboard = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showLeaderboard(0);
  //        }
  //    }
  //    var leaderboardBtn = new Button(p.content, "", "leaderboard.png", showLeaderboard, ICON_BUTTON);
  //    leaderboardBtn.setTransform(-150, 350);
  //    leaderboardBtn.alpha = 0;
  //    leaderboardBtn.scale.set(0.5);
  //    TweenMax.to(leaderboardBtn, 0.3, {
  //        pixi: {
  //            scale: 1,
  //            alpha: 1,
  //        },
  //        delay: 3.3 + mainDelay,
  //        ease: Back.easeOut.config(1.7),
  //    });
  //
  //    var showAchievements = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.showAchievements();
  //        }
  //    }
  //    var achievementsBtn = new Button(p.content, "", "achievements.png", showAchievements, ICON_BUTTON);
  //    achievementsBtn.setTransform(0, 350);
  //    achievementsBtn.alpha = 0;
  //    achievementsBtn.scale.set(0.5);
  //    TweenMax.to(achievementsBtn, 0.3, {
  //        pixi: {
  //            scale: 1,
  //            alpha: 1,
  //        },
  //        delay: 3.4 + mainDelay,
  //        ease: Back.easeOut.config(1.7),
  //    });
  //
  //    var share = function () {
  //        if (window.JSInterface != undefined) {
  //            window.JSInterface.shareText(getText("shareScore", [gameLogic.score]));
  //
  //        }
  //    }
  //
  //    var shareBtn = new Button(p.content, "", "share.png", share, ICON_BUTTON);
  //    shareBtn.setTransform(150, 350);
  //    shareBtn.alpha = 0;
  //    shareBtn.scale.set(0.5);
  //    TweenMax.to(shareBtn, 0.3, {
  //        pixi: {
  //            scale: 1,
  //            alpha: 1,
  //        },
  //        delay: 3.5 + mainDelay,
  //        ease: Back.easeOut.config(1.7),
  //    });
};

gameScreen.openPowerUpInfo = function (index) {
  gameLogic.lock = true;
  ads.gameplayStop();

  var p = alertPopup();
  var titleTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 80,
    fill: [primaryPalette[1]],
    align: "center",
  });

  var infoTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 40,
    fill: [primaryPalette[1]],
    align: "center",
    wordWrap: true,
    wordWrapWidth: 1000,
  });

  var msgTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 35,
    fill: [primaryPalette[1]],
    align: "center",
    wordWrap: true,
    wordWrapWidth: 1000,
  });

  var title = new Text(p.content, getText("powerUpTitle" + index), titleTextStyle);
  title.setTransform(0, -350);

  var img = new Sprite(p.content, "PU_" + index + ".png");
  img.setTransform(0, title.y / 2, 1.5, 1.5);

  var info = new Text(p.content, getText("powerUpText" + index), infoTextStyle);
  info.setTransform(0, -45);
  info.anchor.set(0.5, 0);

  if (ads.getWaitingTime() === 0) {
    var msg = new Text(p.content, getText("ad"), msgTextStyle);
    msg.setTransform(0, info.y + info.height + 40);
  }
  var okBtn = new SpriteButton(p.content, null, "check.png", true, [2, 2]);
  okBtn.setTransform(100, -title.y, 0.5, 0.5);
  okBtn.callback = function () {
    playSound("btnClick");
    gameLogic.lastPowerUp = index;

    closePopup();
    okBtn.disable();
    closeBtn.disable();
    if (isConnected()) {
      ads.showRewardedVideo(gameLogic.powerUpName[index]);
    } else {
      p.closeCallback = function () {
        gameScreen.openWarning("noInternetTitle", "noInternetText");
      };
    }
  };

  var closeBtn = new SpriteButton(p.content, null, "close.png", true, [1.5, 1.5]);
  closeBtn.setTransform(-okBtn.x, okBtn.y, 0.5, 0.5);
  closeBtn.callback = function () {
    playSound("btnClick");
    closePopup();
    okBtn.disable();
    closeBtn.disable();
    if (index == gameLogic.PU_UNDO) {
      gameLogic.gameOver = true;
      gameLogic.lock = true;
      p.closeCallback = function () {
        gameScreen.openGameOver();
      };
      setTimeout(gameLogic.clearState, 50);
    } else {
      p.closeCallback = function () {
        gameLogic.lock = false;
      };
    }
  };
};

gameScreen.openWarning = function (title, text) {
  if (gameLogic.gameOver) return;

  ads.gameplayStop();

  var p = alertPopup();
  var titleTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 80,
    fill: [primaryPalette[1]],
    align: "center",
  });

  var infoTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 40,
    fill: [primaryPalette[1]],
    align: "center",
    wordWrap: true,
    wordWrapWidth: 650,
  });

  var msgTextStyle = new PIXI.TextStyle({
    fontFamily: "manrope-medium",
    fontSize: 35,
    fill: [primaryPalette[1]],
    align: "center",
    wordWrap: true,
    wordWrapWidth: 1000,
  });

  var title = new Text(p.content, getText(title), titleTextStyle);
  title.setTransform(0, -350);

  var img = new Sprite(p.content, "warning.png");
  img.setTransform(0, title.y / 2, 1.25, 1.25);

  var info = new Text(p.content, getText(text), infoTextStyle);
  info.setTransform(0, -45);
  info.anchor.set(0.5, 0);

  var okBtn = new SpriteButton(p.content, null, "check.png", true, [2, 2]);
  okBtn.setTransform(0, -title.y, 0.5, 0.5);
  okBtn.callback = function () {
    playSound("btnClick");
    closePopup();
    okBtn.disable();
    p.closeCallback = function () {
      gameScreen.openPowerUpInfo(gameLogic.lastPowerUp);
    };
  };
};

gameScreen.showBgGlow = function () {
  TweenMax.to(gameScreen.bgGlow, 3, {
    pixi: {
      alpha: 1,
    },
  });

  TweenMax.to(gameScreen.dust, 3, {
    pixi: {
      alpha: 1,
    },
  });

  if (tutorial.isDrawn) {
    tutorial.handContainer.scale.set(0.5);
    TweenMax.to(tutorial.handContainer, 0.5, {
      pixi: {
        alpha: 1,
        scale: 1,
      },
      ease: Back.easeOut.config(1.7),
      onComplete: tutorial.playStep,
    });
  }
};

//resize
gameScreen.resize = function () {
  var s = gameScreen;
  if (!s.isDrawn) {
    return;
  }
  if (!s.root.visible) {
    return;
  }

  var w = APP.screen.width;
  var h = APP.screen.height;

  s.background.width = w;
  s.background.height = h;
  s.backgroundBlack.width = w;
  s.backgroundBlack.height = h;

  s.bgGlow.setTransform(w / 2, h / 2, ratio_scale, ratio_scale);
  s.bgGlowBlack.setTransform(w / 2, h / 2, ratio_scale, ratio_scale);

  s.nextNumContainer.scale.set(ratio_scale);
  s.nextNumContainer.setTransform(w / 2, s.nextNumContainer.height / 2 + 40 * ratio_scale);
  s.scoreContainer.setTransform(w - 40 * ratio_scale, 30 * ratio_scale, ratio_scale, ratio_scale);
  s.menuBtnContainer.setTransform(40 * ratio_scale, 40 * ratio_scale, ratio_scale, ratio_scale);

  //landscape (16:9)
  if (currentFormat == LANDSCAPE) {
    s.numbersContainer.rotation = degToRad(90);
    s.bgGlow.rotation = degToRad(90);
    s.bgGlowBlack.rotation = degToRad(90);
    s.numContParent.setTransform(w / 2, h / 2, ratio_scale * 0.85, ratio_scale * 0.85);
    s.powerUpContainer.setTransform(w / 2, h - 75 * ratio_scale, ratio_scale, ratio_scale);
  }

  //portrait (9:16)
  else if (currentFormat == PORTRAIT) {
    s.numbersContainer.rotation = degToRad(0);
    s.bgGlow.rotation = degToRad(0);
    s.bgGlowBlack.rotation = degToRad(0);

    s.numContParent.setTransform(w / 2, h / 2, ratio_scale, ratio_scale);
    if (w / h > 0.85) {
      s.numContParent.setTransform(w / 2, h / 2, ratio_scale * 0.66, ratio_scale * 0.66);
    } else {
      if (w / h > 0.7) {
        s.numContParent.setTransform(w / 2, h / 2, ratio_scale * 0.8, ratio_scale * 0.8);
      }
    }

    if (w / h < 0.66) {
      s.powerUpContainer.setTransform(w / 2, h - 100 * ratio_scale, ratio_scale * 1.33, ratio_scale * 1.33);
    } else {
      s.powerUpContainer.setTransform(w / 2, h - 75 * ratio_scale, ratio_scale * 1, ratio_scale * 1);
    }
  }

  //desktop (4:3)
  else if (currentFormat == DESKTOP) {
    s.numbersContainer.rotation = degToRad(90);
    s.bgGlow.rotation = degToRad(90);
    s.bgGlowBlack.rotation = degToRad(90);
    s.numContParent.setTransform(w / 2, h / 2, ratio_scale * 0.85, ratio_scale * 0.85);
    s.powerUpContainer.setTransform(w / 2, h - 75 * ratio_scale, ratio_scale, ratio_scale);
  }

  if (gameLogic.numbers[0]) {
    for (var i = 0; i < gameLogic.m; i++) {
      for (var j = 0; j < gameLogic.n; j++) {
        gameLogic.numbers[i][j].rotation = -s.numbersContainer.rotation;
      }
    }
  }
};

resize_methods.push(gameScreen.resize);

//delete
gameScreen.delete = function () {
  gameScreen.root.delete();
  gameScreen.isDrawn = false;
};
